import classnames from "classnames";
import classes from "../../../styles/Subscription.module.scss";
import Footer from "../../../components/common/Footer/Footer";
import Header from "../../../components/common/Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_PATH } from "../../../routes/route";
import SubmitForm from "./SubmitForm";

function FreeTrialForm() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <div>
        <Header />
        <div className="containerWidth">
          <div className={classnames(classes.breadcrumb)}>
            <div
              onClick={() => navigate(`${APP_PATH}/home`)}
              className={classes.notactive}
            >
              Home
            </div>
            /
            <div
              onClick={() => navigate(`${APP_PATH}/subscription`)}
              className={classes.notactive}
            >
              Subscription
            </div>
            /<div>{location.state.plan}</div>
            {/* /<div>Free trial</div> */}
          </div>
        </div>
        <div
          className={classnames(
            classes.freeTrialFormContainer,
            "minheightCont100vh"
          )}
        >
          <div className={classes.heading}>{location.state.planType==="Trial"?`Start your free trial now`:location.state.planType==="Custom"?`Thank you for choosing Custom Plan`:`Thank you for choosing ${location.state.plan}`}</div>
          <div className={classes.subheading}>
          {location.state.planType==="Trial"?`Start your free trial now and drive more sales and leads for `:location.state.planType==="Custom"?`Please enter your details, our team would reach out to you soon.`:`Please enter your details to activate your plan and drive more sales and leads for `}
            
            {location.state.planType!=="Custom"&& <br></br>}
            {location.state.planType!=="Custom"&& `your business from day one.`}
          </div>
          <SubmitForm planName={location.state.plan} planType={location.state.planType}/>
          
        </div>
        <Footer />
      </div>
    </>
  );
}



export default FreeTrialForm;
